import { Genre, Instrument, Sfx, Tag } from 'types/generated';
import { ApiFilter, ApiFilterItem } from '../types';

export const getMergedFilters = (
    loading: boolean,
    filtersData?: {
        [key: string]: Instrument[] | Genre[] | Sfx[] | Tag[];
    },
) => {
    const staticFilters = [
        {
            name: 'Type',
            list: [{ code: 'one_shot' }, { code: 'loop' }],
        },
    ];

    let filtersDataArr: ApiFilter[] = [];

    if (!loading && filtersData) {
        filtersDataArr = Object.keys(filtersData).map((key) => {
            return {
                name: key.charAt(0).toUpperCase() + key.slice(1),
                list: filtersData[key] as ApiFilterItem[],
            };
        });
    }

    return [...filtersDataArr, ...staticFilters];
};
